var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('StandardLayout',[_c('button',{on:{"click":_vm.onToggle}},[_vm._v(_vm._s(_vm.$t("admin.playground.modal")))]),(_vm.modalOpen)?_c('StationPickerModal',{attrs:{"stations":_vm.stations},on:{"close":_vm.onToggle}}):_vm._e(),_c('div',[_c('UserPicker',{on:{"picked":_vm.onUser}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }